/**
 * Collection Variant Pills
 * Handles pill click → update price, card link URL, and selected state
 */
if (!customElements.get('collection-variant-pills')) {
    class CollectionVariantPills extends HTMLElement {
        connectedCallback() {
            this.pills = this.querySelectorAll('.collection-variant-pills__pill');
            this.productId = this.dataset.productId;
            this.productCard = this.closest('product-card');

            this.pills.forEach((pill) => {
                pill.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (pill.disabled) return;
                    this.selectPill(pill);
                });
            });
        }

        selectPill(pill) {
            // Update active states
            this.pills.forEach((p) => {
                p.classList.remove('collection-variant-pills__pill--active');
                p.setAttribute('aria-checked', 'false');
            });
            pill.classList.add('collection-variant-pills__pill--active');
            pill.setAttribute('aria-checked', 'true');

            // Get variant data
            const variantPrice = parseInt(pill.dataset.variantPrice, 10);
            const variantComparePrice = parseInt(pill.dataset.variantComparePrice, 10);
            const variantUrl = pill.dataset.variantUrl;

            // Update price display
            this.updatePrice(variantPrice, variantComparePrice);

            // Update card link
            this.updateCardLink(variantUrl);
        }

        updatePrice(price, comparePrice) {
            if (!this.productCard) return;

            const priceEl = this.productCard.querySelector('product-price');
            if (!priceEl) return;

            const priceSpan = priceEl.querySelector('.price');
            const compareSpan = priceEl.querySelector('.compare-at-price');

            if (priceSpan && price) {
                priceSpan.textContent = this.formatMoney(price);
            }

            if (compareSpan) {
                if (comparePrice && comparePrice > price) {
                    compareSpan.textContent = this.formatMoney(comparePrice);
                    compareSpan.style.display = '';
                } else {
                    compareSpan.style.display = 'none';
                }
            }

            // Update unit price if exists
            const unitPriceEl = priceEl.querySelector('.unit-price');
            if (unitPriceEl) {
                unitPriceEl.style.display = 'none';
            }
        }

        updateCardLink(url) {
            if (!this.productCard || !url) return;

            const link = this.productCard.querySelector('.product-card__link');
            if (link) {
                link.href = url;
            }

            // Also update title link
            const titleLink = this.productCard.querySelector('[ref="productTitleLink"]');
            if (titleLink) {
                titleLink.href = url;
            }

            // Also update CTA "Create your magnets" link
            const ctaLink = this.productCard.querySelector('.collection-cta');
            if (ctaLink) {
                ctaLink.href = url;
            }
        }

        formatMoney(cents) {
            // Use Shopify's money format if available
            if (window.Shopify && window.Shopify.formatMoney) {
                return window.Shopify.formatMoney(cents);
            }

            // Fallback: detect currency from existing price text
            const existingPrice = this.productCard?.querySelector('.price');
            if (existingPrice) {
                const text = existingPrice.textContent.trim();
                // Detect if currency uses comma as decimal (e.g., "797.000₫")
                const hasDong = text.includes('₫') || text.includes('đ');
                if (hasDong) {
                    const formatted = new Intl.NumberFormat('vi-VN').format(cents / 100);
                    // Check if the original uses ₫ suffix
                    if (text.includes('₫')) return formatted + '₫';
                    if (text.includes('đ')) return formatted + 'đ';
                    return formatted + '₫';
                }

                const hasPound = text.includes('£');
                if (hasPound) {
                    return '£' + (cents / 100).toFixed(2);
                }

                const hasDollar = text.includes('$');
                if (hasDollar) {
                    return '$' + (cents / 100).toFixed(2);
                }

                const hasEuro = text.includes('€');
                if (hasEuro) {
                    return '€' + (cents / 100).toFixed(2);
                }
            }

            // Ultimate fallback
            return (cents / 100).toFixed(2);
        }
    }

    customElements.define('collection-variant-pills', CollectionVariantPills);
}
